
        import 'Partner.b8bd5df.css-module'
        export default {"partner":"partner_Partner_b8bd5df"}
    